<template>
  <base-input input-type="tel"
              :label="label"
              :min="'0'"
              :value="value.toString()"
              size="large"
              v-on="listeners"
              class="amount-input"
              @keypress="preventKeys"
              @input="onInputToNumber"
              @focus="onFocus">
    <template v-slot:append>
      <span class="currency-icon">₪</span>
    </template>
  </base-input>
</template>

<script>
import BaseInput from './BaseInput.vue';

export default {
  name: 'AmountInput',
  components: { BaseInput },
  props: {
    value: {
      type: Number,
      required: true,
    },
    autofocus: {
      type: Boolean,
      default: true,
    },
    label: {
      type: String,
      required: true,
    },
  },
  computed: {
    listeners() {
      // eslint-disable-next-line no-unused-vars
      const { input, ...listeners } = this.$listeners;
      return listeners;
    },
  },
  methods: {
    preventKeys(event) {
      if (event.key === '-' || event.key === 'e') {
        return event.preventDefault();
      }
      return true;
    },
    onInputToNumber(value) {
      const numberValue = Number(value);
      if (Number.isNaN(numberValue)) {
        throw new Error(`Amount is not a number. value: ${value}`);
      }
      this.$emit('input', numberValue);
    },
    onFocus(event) {
      event.target.select();
    },
  },
};
</script>

<style scoped lang="scss">
  @import '../scss/riseup-colors';

  .currency-icon {
    font-family: SimplerProBold;
    font-size: 32px;
    color: $riseup_blue;
  }
</style>
